import { client } from "./_base";

export const arrivaldetails = client("arrivaldetail", item => ({
  ...item,
}));